<section class="about-us" id="about">
  <div class="container">
    <div class="about-content">
      <!-- Szöveg -->
      <div class="about-text">
        <h1 class="headline">{{ 'about-section.title' | translate }}</h1>
        <p class="intro-text">{{ 'about-section.intro' | translate }}</p>

        <div class="about-features">
          <h2 class="subhead">{{ 'about-section.features-title' | translate }}</h2>
          <p>{{ 'about-section.features-intro1' | translate }}</p>
          <p>{{ 'about-section.features-intro2' | translate }}</p>
          <p>{{ 'about-section.features-intro3' | translate }}</p>
        </div>

        <p class="closing-text">
          {{ 'about-section.closing-1' | translate }}
          <strong>{{ 'about-section.closing-2' | translate }}</strong>
        </p>
      </div>

      <!-- Képváltó -->
      <div class="about-visual">
        <div #imageSlider class="image-slider">
          <img src="assets/images/tavaszi_csokor.jpg" alt="Csokor 1" class="active" />
          <img src="assets/images/viragdoboz.jpg" alt="Csokor 2" />
          <img src="assets/images/peaonia.jpg" alt="Csokor 3" />
        </div>
      </div>
    </div>
  </div>
</section>
